import { Component, OnInit, AfterViewInit, OnDestroy, PLATFORM_ID, Inject } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-webi',
    templateUrl: './webi.component.html',
    styleUrls: ['./webi.component.scss'],
    standalone: true,
    imports: [CommonModule]
})
export class WebiComponent implements OnInit, AfterViewInit, OnDestroy {
  minutes: number = 15;
  seconds: number = 0;
  private timer: any;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit(): void {
    // Initialize with default values
    this.minutes = 15;
    this.seconds = 0;
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.startCountdown();
    }
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId) && this.timer) {
      clearInterval(this.timer);
    }
  }

  startCountdown() {
    if (!isPlatformBrowser(this.platformId)) return;

    this.timer = setInterval(() => {
      if (this.seconds === 0) {
        if (this.minutes === 0) {
          clearInterval(this.timer);
        } else {
          this.minutes--;
          this.seconds = 59;
        }
      } else {
        this.seconds--;
      }
    }, 1000);
  }
}


